import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {Location} from '@reach/router';

import useBeacon from 'utils/useBeacon';
import useBalanceText from 'utils/useBalanceText';

import PageMeta from 'components/PageMeta';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import Footer from 'components/Footer';

export default function (props) {
  return <Location>{({location}) => <ChallengeWelcomeWLC location={location} {...props} />}</Location>;
}

function ChallengeWelcomeWLC({
  pageTitle = 'Thank You for Joining the Challenge!',
  pageDescription = 'What if the foods you DO eat matter even more than the ones you swear off? Something as simple as adding more plant-powered superfoods to your meals makes all the difference for your gut, heart, and overall health. Plus, easy-to-make recipes fill you up, so you naturally “crowd out” tempting but troublesome choices. That’s why you’re invited to join us for this free, easy, and delicious challenge: Discover how to effortlessly add 30 plants to your diet… in just 3 days!',
  ogUrl = 'https://wlc.foodrevolution.org/challenge/',
  ogImage = 'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/wlc/challenge/og/wlc-lc-open_graph-202501.jpg',
  location = {},
  ...props
}) {
  useBeacon();
  useBalanceText();
  return (
    <div className="page page-nosocial d-flex flex-column">
      <PageMeta title={pageTitle} description={pageDescription} ogImage={ogImage} url={ogUrl} />
      <div className="page-content d-flex flex-column flex-grow-1">
        <SectionCL
          id="welcome-header"
          color="light-gray"
          className="text-center text-white flex-grow-1"
          innerWrapClass="d-flex flex-column flex-grow-1"
          innerClass="py-5 my-auto"
          angle="none"
          imgUrl="https://cdn.foodrevolution.org/eattherainbow/images/1129818010-lg.jpg"
        >
          <Container>
            <Row>
              <Col>
                <div className="background-black-90 rounded p-4 p-lg-5">
                  <h2 className="section-heading">Thank You for Joining the Powered by Plants Challenge!</h2>
                  <p className="text-h5">We’re going to share an amazing three days together!</p>
                  <p className="text-h5">
                    <b>Be sure to check your email inbox.</b>
                  </p>
                  <p className="balance-text text-h5">
                    In just a few minutes, you’ll receive an email with all the information you need to participate in
                    the Challenge!
                  </p>
                  <p className="text-h5">Here’s to a plant-powered journey. Let’s do this! 🌱</p>
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      </div>
      <Footer className="mt-auto" />
    </div>
  );
}
